import React from "react";
import './styles.scss'

import {Text} from '@mantine/core';
import { useShipmentOperationsMilestones } from "../../../api/Shipment.Milestones/Shipment.Milestones.hooks";
import ShipmentTimeline from "../Shipment.timeline/Shipment.timeline";

interface Props {
    referenceNumber?: string
}

function ShipmentOperationsMilestones ({referenceNumber}: Props) {
    const {isLoading, data} = useShipmentOperationsMilestones({referenceNumber})

    if(isLoading || !data)
    {
        return (<div>Loading...</div>);
    }

    return (
        <div className="milestones-operation">
            <Text size="lg" color="gray" align="center">Information</Text>
            <div style={{marginTop:24}}> 
                <ShipmentTimeline milestones={data}></ShipmentTimeline>
            </div>
        </div>
    )
}

export default ShipmentOperationsMilestones;